<template>
  <b-container class="mt-1 mt-md-3 py-md-2 py-1 bg-white content-page">
    <b-row class="my-3">
      <b-col class="text-center">
        <h1 class="header-login mt-3">{{ $t("ourPartner") }}</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="d-flex justify-content-end mb-3">
          <b-input-group class="panel-input-serach">
            <b-form-input
              class="input-serach"
              :placeholder="$t('findPartner')"
              v-model="filter.search"
              @keyup="handleSearch"
            ></b-form-input>
            <b-input-group-prepend @click="btnSearch">
              <span class="icon-input m-auto pr-2">
                <font-awesome-icon icon="search" title="View" />
              </span>
            </b-input-group-prepend>
          </b-input-group>
        </div>
      </b-col>
    </b-row>
    <!-- <pre>{{profileInfo}}</pre> -->
    <div
      v-if="total == 0 && !isLoading"
      :class="[
        'body-products d-flex justify-content-center align-items-center',
      ]"
    >
      <div class="text-center text-gray-3">
        <p>{{ $t("partnerNotFound") }}</p>
      </div>
    </div>
    <div
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="busy"
      infinite-scroll-distance="10"
    >
      <b-row>
        <b-col
          class="col-md-2 col-4"
          v-for="item in partnerList"
          v-bind:key="item.id"
        >
          <PartnerPanelCard :data="item" />
        </b-col>
      </b-row>
      <div
        class="
          text-center
          body-products
          d-flex
          justify-content-center
          align-items-center
        "
        v-if="isLoading"
      >
        <div class="text-center">
          <b-spinner
            label="Loading..."
            variant="warning"
            class="m-5 spinner-main"
          ></b-spinner>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapState } from "vuex";
import PartnerPanelCard from "./componants/PartnerPanelCard.vue";

export default {
  name: "partnerList",
  components: {
    PartnerPanelCard,
  },
  data() {
    return {
      busy: false,
      isLoading: false,
      total: -1,
      filter: {
        pageNo: 0,
        perPage: 35,
        search: "",
      },
      partnerList: [],
      timer: null,
    };
  },
  computed: {
    ...mapState({
      profileInfo: state => state.profile,
    }),
  },
  methods: {
    async getPartnerList() {
      this.isLoading = true;
      let resData = await this.$callApi(
        "get",
        `${this.$baseUrl}/api/product/Products/Partner/page/${this.filter.pageNo}/perpage/${this.filter.perPage}?search=${this.filter.search}`,
        null,
        this.$headers,
        null
      );
      if (resData.result == 1) {
        if (this.filter.pageNo == 1) {
          this.partnerList = [];
          this.busy = false;
          this.total = resData.detail.count;
        }
        this.partnerList = this.partnerList.concat(resData.detail.dataList);
        if (
          this.total == 0 ||
          resData.detail.dataList.length == 0 ||
          resData.detail.count === this.partnerList.length
        ) {
          this.busy = true;
        }
      }
      this.isLoading = false;
    },
    loadMore: async function() {
      this.filter.pageNo++;
      await this.getPartnerList();
    },
    handleSearch(e) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.filter.pageNo = 1;
        this.getPartnerList();
      }, 800);
    },
    btnSearch() {
      this.filter.pageNo = 1;
      this.getPartnerList();
    },
  },
  created: async function() {
    await this.$store.dispatch("getUserApi");

    if (!this.profileInfo.isAdmin)
      this.$router.push({ path: `/dashboard/productoverview` });
    await this.getPartnerList();
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 80% !important;
}

.panel-input-serach,
.statusListDropdown {
  border: 2px solid #092d53 !important;
}
</style>
